import HttpClient from '../util/http/HttpClient'
import HttpClientAxios from '../util/http/HttpClientAxios'
import { WishlistAxiosOptions } from '../objects/wishlist'
import {
  GetWishlistParams,
  PutWishlistParams
} from '../connectors/interfaces/parameters'
import getWishlistsByCustomerSourceIdQuery from '../connectors/graphql/queries/getWishlistsByCustomerSourceIdQuery'
import putWishlistMutation from '../connectors/graphql/mutations/putWishlistMutation'

export interface NacelleWishlistParams {
  endpoint?: string
  httpClient?: HttpClient
  spaceId: string
  token: string
}

export default class NacelleWishlist {
  endpoint: string
  apiClient: HttpClient

  constructor(params: NacelleWishlistParams) {
    if (params && params.endpoint && params.endpoint.length > 0) {
      this.endpoint = params.endpoint
    } else if (
      process &&
      process.env &&
      process.env.NACELLE_WISHLIST_ENDPOINT &&
      process.env.NACELLE_WISHLIST_ENDPOINT.length > 0
    ) {
      this.endpoint = process.env.NACELLE_WISHLIST_ENDPOINT
    } else {
      // Set default Wishlist endpoint
      this.endpoint = 'https://wishlist.hailfrequency.com/graphql'
    }

    const axiosOptions: WishlistAxiosOptions = {
      headers: {
        'Content-Type': 'application/json',
        'X-Nacelle-Space-Id': params.spaceId,
        'X-Nacelle-Space-Token': params.token
      }
    }

    this.apiClient =
      params && params.httpClient
        ? params.httpClient
        : new HttpClientAxios(axiosOptions)
  }

  put(params: PutWishlistParams): Promise<any> {
    return this.apiClient.post(this.endpoint, {
      query: putWishlistMutation,
      variables: { input: { ...params } }
    })
  }

  get(params: GetWishlistParams): Promise<any> {
    return this.apiClient.post(this.endpoint, {
      query: getWishlistsByCustomerSourceIdQuery,
      variables: params
    })
  }
}
